<template>
    <div>
        <b-form-group
        class="input-group-var-regio"
        label="Regió"
        label-size="sm"
        label-for="input-var-regio"
        label-cols="4"
        >
            <b-form-select
            required
            size="sm"
            id="input-var-regio"
            class="var-regio"
            v-model="regio"
            :options="opcionsRegio"
            @input="onUpdateRegio"
            >
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "VariableRegio",
    props: {
        initialValue:{
            required: true,
        },
    },
    data(){
        return {
            codiVariable: "regio",
            regio: null,
            opcionsRegio: [
                { value: "1", text: this.$t("fitxes.tipusRegio.1") },
                { value: "2", text: this.$t("fitxes.tipusRegio.2") },
                { value: "3", text: this.$t("fitxes.tipusRegio.3") },
                { value: "4", text: this.$t("fitxes.tipusRegio.4") },
                { value: "5", text: this.$t("fitxes.tipusRegio.5") },
                { value: "6", text: this.$t("fitxes.tipusRegio.6") },
                { value: "7", text: this.$t("fitxes.tipusRegio.7") },
                { value: "8", text: this.$t("fitxes.tipusRegio.8") },
                { value: "9", text: this.$t("fitxes.tipusRegio.9") },
                { value: "10", text: this.$t("fitxes.tipusRegio.10") },
            ],
        };
    },
    computed: {
        returnValue(){
            let r = {codi: this.codiVariable};
            if(this.regio != null){
                r.regio = this.regio
            }

            return r;
        },
    },
    methods: {
        onUpdateRegio(newValue){
            this.$emit("regio-seleccionat", newValue);
        },
    },
    mounted(){
        if(this.initialValue != null){
            this.regio = this.initialValue.valor;
        } else{
            this.regio = "1";
        }
    }
}
</script>
<style>
.var-regio {
  width: 250px;
}
.input-group-var-regio .col {
  text-align: left;
}
</style>